var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import '@src/app/styles/datatable.css';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useProcessSchedule } from '@src/components/molecules/Schedule/NoSchedule/NoSchedule.request';
import InputFormik from '../../Formik/Input/InputFormik';
import FileFormik from '../../Formik/Input/FileFormik';
import { uploadFile } from '@src/app/pages/JobPage/Job/Job.requests';
import { Divider } from '@mui/material';
import { useParams } from 'react-router-dom';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import SelectFormik from '../../Formik/Select/SelectFormik';
import { useProductCategory } from '@src/app/pages/ProductCategoryPage/ProductCategoryHooks/ProductCategory.hooks';
var EditScheduleForm = function (_a) {
    var _b;
    var record = _a.record, refetch = _a.refetch, handleClose = _a.handleClose;
    var id = useParams().id;
    var editSchedule = useProcessSchedule(id).editSchedule;
    var _c = useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = useState(true), showInsight = _d[0], setShowInsight = _d[1];
    var _e = useState({
        proofUploadFilePubId: '',
    }), files = _e[0], setFiles = _e[1];
    var onChangeFiles = function (e) {
        var _a;
        setFiles(__assign(__assign({}, files), (_a = {}, _a[e.target.name] = e.target.files, _a)));
        EditFormik.setFieldValue(e.target.name, e.target.files);
    };
    var UpFormSchema = Yup.object().shape({
        productCategoryPubId: Yup.string().required('Field belum diisi'),
        proofUploadFilePubId: Yup.string().required('Field belum diisi'),
    });
    var EditFormik = useFormik({
        initialValues: {
            upLink: '',
            proofUploadFilePubId: '',
            views: record.schedule.views || '',
            likes: record.schedule.likes || '',
            share: record.schedule.share || '',
            comment: record.schedule.comment || '',
            impression: record.schedule.impression || '',
            reach: record.schedule.reach || '',
            productCategoryPubId: ((_b = record.schedule.productCategory) === null || _b === void 0 ? void 0 : _b.pubId) || '',
        },
        enableReinitialize: true,
        validationSchema: UpFormSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var proof, formValues, views, likes, share, comment, impression, reach, productCategoryPubId, finalViews, finalLikes, finalShare, finalComment, finalImpression, finalReach, formData, e_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        setIsSubmitting(true);
                        return [4 /*yield*/, uploadFile({
                                File: files.proofUploadFilePubId[0],
                                TenantPubId: record.tenantId,
                                TalentPubId: record.talentId,
                                Type: 'ProofOfUploads',
                            })];
                    case 1:
                        proof = _a.sent();
                        formValues = __assign({}, values);
                        views = formValues.views, likes = formValues.likes, share = formValues.share, comment = formValues.comment, impression = formValues.impression, reach = formValues.reach, productCategoryPubId = formValues.productCategoryPubId;
                        finalViews = typeof views == 'string' ? views.replace(/\./g, '') : parseInt(views).toString();
                        finalLikes = typeof likes == 'string' ? likes.replace(/\./g, '') : parseInt(likes).toString();
                        finalShare = typeof share == 'string' ? share.replace(/\./g, '') : parseInt(share).toString();
                        finalComment = typeof comment == 'string' ? comment.replace(/\./g, '') : parseInt(comment).toString();
                        finalImpression = typeof impression == 'string'
                            ? impression.replace(/\./g, '')
                            : parseInt(impression).toString();
                        finalReach = typeof reach == 'string' ? reach.replace(/\./g, '') : parseInt(reach).toString();
                        formData = {
                            upLink: values.upLink,
                            proofUploadFilePubId: proof.data.data.pubId,
                            views: finalViews,
                            likes: finalLikes,
                            share: finalShare,
                            comment: finalComment,
                            impression: finalImpression,
                            reach: finalReach,
                            productCategoryPubId: productCategoryPubId,
                        };
                        if (!(proof.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, editSchedule(__assign({ id: record.schedule.pubId }, formData))];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        e_1 = _a.sent();
                        error = e_1.response.data;
                        toast.error(error.message);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsSubmitting(false);
                        handleClose(false);
                        refetch();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); },
    });
    var _f = useProductCategory(), productCategory = _f.productCategory, isLoadingProductCategory = _f.isLoading, errorSocialMedia = _f.error;
    var optionProductCategory = productCategory &&
        productCategory.length > 0 &&
        productCategory.map(function (category) { return ({
            name: category.name,
            value: category.pubId,
        }); });
    return (_jsx("div", __assign({ className: 'mb-5' }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: 'mb-5' }, { children: [_jsx("div", { children: _jsx("label", __assign({ className: "form-label fs-6 fw-bolder text-dark" }, { children: "Nama" })) }), _jsxs("div", __assign({ className: "form-label fs-6 fw-bolder text-dark" }, { children: [record.jobDetail.profile.profileName, " -", ' ', _jsx("a", __assign({ href: record.jobDetail.profile.profileLink }, { children: record.jobDetail.profile.socialMedia.name }))] }))] })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Up Link', formik: EditFormik, name: 'upLink', placeholder: 'Up Link', type: 'text' }) }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx("div", { children: _jsx(FileFormik, { label: 'Bukti Upload', placeholder: 'Bukti Upload', name: 'proofUploadFilePubId', isRequired: true, formik: EditFormik, onChange: onChangeFiles }) }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: !isLoadingProductCategory && optionProductCategory && (_jsx(SelectFormik, { name: 'productCategoryPubId', label: 'Kategori Barang', formik: EditFormik, optionList: optionProductCategory, isRequired: true })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Views', type: 'text', placeholder: 'Views', name: 'views', formik: EditFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Likes', type: 'text', placeholder: 'Likes', name: 'likes', formik: EditFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Share', type: 'text', placeholder: 'Share', name: 'share', formik: EditFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Comments', type: 'text', placeholder: 'Comments', name: 'comment', formik: EditFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Impression', type: 'text', placeholder: 'Impression', name: 'impression', formik: EditFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Reach', type: 'text', placeholder: 'Reach', name: 'reach', formik: EditFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", { children: _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-active-light-primary btn-sm mr-2', disabled: isSubmitting, onClick: function () { return EditFormik.handleSubmit(); } }, { children: [!isSubmitting && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), isSubmitting && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] })) })] }) })));
};
export default EditScheduleForm;
